"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tooltipClassNames: function() {
        return tooltipClassNames;
    },
    useTooltipStyles_unstable: function() {
        return useTooltipStyles_unstable;
    }
});
const _react = require("@griffel/react");
const tooltipClassNames = {
    content: 'fui-Tooltip__content'
};
/**
 * Styles for the tooltip
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "fjseox",
        B7ck84d: "f1ewtqcl",
        B2u0y6b: "f132xexn",
        Bceei9c: "f158kwzp",
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bg96gwp: "fwrc4pm",
        Btd35i7: "fokg9q4",
        Bbmb7ep: [
            "f1aa9q02",
            "f16jpd5f"
        ],
        Beyfa6y: [
            "f16jpd5f",
            "f1aa9q02"
        ],
        B7oj6ja: [
            "f1jar5jt",
            "fyu767a"
        ],
        Btl43ni: [
            "fyu767a",
            "f1jar5jt"
        ],
        B4j52fo: "f5ogflp",
        Bekrc4i: [
            "f1hqa2wf",
            "finvdd3"
        ],
        Bn0qgzm: "f1f09k3d",
        ibv6hh: [
            "finvdd3",
            "f1hqa2wf"
        ],
        icvyot: "fzkkow9",
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        oivjwe: "fg706s2",
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        g2u3we: "fghlq4f",
        h3c5rm: [
            "f1gn591s",
            "fjscplz"
        ],
        B9xav0g: "fb073pr",
        zhjwy3: [
            "fjscplz",
            "f1gn591s"
        ],
        z8tnut: "f10ra9hq",
        z189sj: [
            "fd9xhir",
            "f1jlaasf"
        ],
        Byoj8tv: "f1d7kygh",
        uwmqm3: [
            "f1jlaasf",
            "fd9xhir"
        ],
        De3pzq: "fxugw4r",
        sj55zd: "f19n0e5",
        Bhu2qc9: "fxeb0a7"
    },
    visible: {
        mc9l5x: "ftgm304"
    },
    inverted: {
        De3pzq: "fg3r6xk",
        sj55zd: "fonrgv7"
    },
    arrow: {
        qhf8xq: "f1euv43f",
        De3pzq: "f1u2r49w",
        Bcdw1i0: "fd7fpy0",
        Bj3rh1h: "f1bsuimh",
        a9b677: "f1ekdpwm",
        Bqenvij: "f83vc9z",
        Ftih45: "f1wl9k8s",
        B1puzpu: "f1wkw4r9",
        Brfgrao: "f1j7ml58",
        Bcvre1j: "fyl8oag",
        Ccq8qp: "frdoeuz",
        Baz25je: "fb81m9q",
        cmx5o7: "f1ljr5q2",
        B4f6apu: "fyfemzf",
        m598lv: "focyt6c",
        Bk5zm6e: "fnhxbxj",
        y0oebl: "fdw6hkg",
        qa3bma: "f11yjt3y",
        Bqjgrrk: "f1172wan",
        Budzafs: [
            "f9e5op9",
            "f112wvtl"
        ],
        Hv9wc6: "f16cagkn",
        hl6cv3: "f1773hnp",
        c8svkw: "fw7o64x",
        yayu3t: "f1v7783n",
        nr3p0k: "f1f0d6v",
        rhl9o9: "fh2hsk5",
        wiz9v7: "f1gj3y7g",
        B6q6orb: "f11yvu4",
        ndpsmx: "f17lejdj"
    }
}, {
    d: [
        ".fjseox{display:none;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f132xexn{max-width:240px;}",
        ".f158kwzp{cursor:default;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".fokg9q4{overflow-wrap:break-word;}",
        ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f5ogflp{border-top-width:1px;}",
        ".f1hqa2wf{border-right-width:1px;}",
        ".finvdd3{border-left-width:1px;}",
        ".f1f09k3d{border-bottom-width:1px;}",
        ".fzkkow9{border-top-style:solid;}",
        ".fcdblym{border-right-style:solid;}",
        ".fjik90z{border-left-style:solid;}",
        ".fg706s2{border-bottom-style:solid;}",
        ".fghlq4f{border-top-color:var(--colorTransparentStroke);}",
        ".f1gn591s{border-right-color:var(--colorTransparentStroke);}",
        ".fjscplz{border-left-color:var(--colorTransparentStroke);}",
        ".fb073pr{border-bottom-color:var(--colorTransparentStroke);}",
        ".f10ra9hq{padding-top:4px;}",
        ".fd9xhir{padding-right:11px;}",
        ".f1jlaasf{padding-left:11px;}",
        ".f1d7kygh{padding-bottom:6px;}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".fxeb0a7{filter:drop-shadow(0 0 2px var(--colorNeutralShadowAmbient)) drop-shadow(0 4px 8px var(--colorNeutralShadowKey));}",
        ".ftgm304{display:block;}",
        ".fg3r6xk{background-color:var(--colorNeutralBackgroundStatic);}",
        ".fonrgv7{color:var(--colorNeutralForegroundStaticInverted);}",
        ".f1euv43f{position:absolute;}",
        ".f1u2r49w{background-color:inherit;}",
        ".fd7fpy0{visibility:hidden;}",
        ".f1bsuimh{z-index:-1;}",
        ".f1ekdpwm{width:8.484px;}",
        ".f83vc9z{height:8.484px;}",
        ".f1wl9k8s::before{content:\"\";}",
        ".f1wkw4r9::before{visibility:visible;}",
        ".f1j7ml58::before{position:absolute;}",
        ".fyl8oag::before{box-sizing:border-box;}",
        ".frdoeuz::before{width:inherit;}",
        ".fb81m9q::before{height:inherit;}",
        ".f1ljr5q2::before{background-color:inherit;}",
        ".fyfemzf::before{border-right-width:1px;}",
        ".focyt6c::before{border-right-style:solid;}",
        ".fnhxbxj::before{border-right-color:var(--colorTransparentStroke);}",
        ".fdw6hkg::before{border-bottom-width:1px;}",
        ".f11yjt3y::before{border-bottom-style:solid;}",
        ".f1172wan::before{border-bottom-color:var(--colorTransparentStroke);}",
        ".f9e5op9::before{border-bottom-right-radius:var(--borderRadiusSmall);}",
        ".f112wvtl::before{border-bottom-left-radius:var(--borderRadiusSmall);}",
        ".f16cagkn::before{transform:rotate(var(--fui-positioning-angle)) translate(0, 50%) rotate(45deg);}",
        "[data-popper-placement^=\"top\"] .f1773hnp{bottom:-1px;}",
        "[data-popper-placement^=\"top\"] .fw7o64x{--fui-positioning-angle:0;}",
        "[data-popper-placement^=\"right\"] .f1v7783n{left:-1px;}",
        "[data-popper-placement^=\"right\"] .f1f0d6v{--fui-positioning-angle:90deg;}",
        "[data-popper-placement^=\"bottom\"] .fh2hsk5{top:-1px;}",
        "[data-popper-placement^=\"bottom\"] .f1gj3y7g{--fui-positioning-angle:180deg;}",
        "[data-popper-placement^=\"left\"] .f11yvu4{right:-1px;}",
        "[data-popper-placement^=\"left\"] .f17lejdj{--fui-positioning-angle:270deg;}"
    ]
});
const useTooltipStyles_unstable = (state)=>{
    const styles = useStyles();
    state.content.className = (0, _react.mergeClasses)(tooltipClassNames.content, styles.root, state.appearance === 'inverted' && styles.inverted, state.visible && styles.visible, state.content.className);
    state.arrowClassName = styles.arrow;
    return state;
}; //# sourceMappingURL=useTooltipStyles.styles.js.map
